'use strict';

angular.module('app.entity.audit')
    .controller('EntityAuditController', [
        'ShareCrfSDK',
        'RecordService',
        'CrdConfigurationService',
        'CrfService',
        'RecordDataService',
        'EcrdService',
        function(
            ShareCrfSDK,
            RecordService,
            CrdConfigurationService,
            CrfService,
            RecordDataService,
            EcrdService
        ) {
            var vm = this;

            vm.initied = false;
            vm.error = false;
            vm.auditData = [];

            ShareCrfSDK.ecrd.getRecordAuditLog(RecordService.getId())
                .then(function(responseData) {
                    vm.auditData = responseData.map(function(line) {
                        line.change = line.change.reduce(function(acc, change) {
                            var changeData = _getChangeData(change);

                            return changeData ? acc.concat(changeData) : acc;
                        }, []);

                        return line;
                    });

                    vm.initied = true;
                })
                .catch(function(error) {
                    vm.error = true;
                });

            vm.hasUnavailableElements = EcrdService.getUnavailableElementsToCurrentProfile().length > 0;

            /**
             * Determina si las dos etiquetas son iguales. Los índices numéricos que puedan aparecer en cualquier
             * componente, los trata igual sean cadenas de texto o números enteros
             *
             * @param  {array} labelA   Primera etiqueta a comparar
             * @param  {array} labelB   Segunda etiqueta a comparar
             *
             * @return {boolean}        TRUE si son iguales
             */
            function sameLabel(labelA, labelB) {
                if (angular.isArray(labelA) && angular.isArray(labelB)) {
                    if (labelA.length === labelB.length) {
                        var index;
                        for (index = 0; index < labelA.length; index++) {
                            if (String(labelA[index]) !== String(labelB[index])) {
                                return false;
                            }
                        }

                        return true;
                    }
                }

                return false;
            }

            // eslint-disable-next-line complexity
            function _getChangeData(change) {
                if (!_isValidChange(change)) {
                    return undefined;
                }

                var format = _getChangeFormat(change);
                if (format) {
                    change.format = format;
                }

                // Lista de acciones que tienen que ver con un elemento concreto
                var itemActions = ['form-metadata', 'modify-data', 'delete', 'add-data', 'add-item', 'delete-item'];
                if (itemActions.indexOf(change.action) > -1) {
                    if (change.uid) {
                        change.fieldUId = angular.isArray(change.uid) ? change.uid.join('.') : change.uid;
                        // se trata de un cambio asociado a un elemento del CRD identificado por su UID
                        var element = CrfService.getElementByUID(change.uid);
                        if (element !== null) {
                            change.fieldName = element.getName();
                            change.fieldId = element.getId();
                            var newLabel = RecordDataService.getElementFullLabeledPathByUID(change.uid);
                            var itemExists = RecordDataService.isElementValid(change.uid);

                            if (change.flag && change.flag !== 'locked') { // si tiene un estado de aprobación
                                var state = CrdConfigurationService.getStates().getState(change.flag);
                                if (state && newLabel) { // GARU-4401
                                    newLabel.push(state.getName());
                                }
                            }

                            if (element.isList()) {
                                change.elementChanged = itemExists && !sameLabel(change.label, newLabel);
                                if (change.action === 'delete' || change.action === 'delete-item' || change.action === 'add-item') {
                                    // campo que pertenece a un ítem de lista, y que además ese ítem de lista se
                                    // ha eliminado de los datos
                                    change.itemDeleted = !itemExists;
                                }
                            } else {
                                if (itemExists) {
                                    // si la acción es un metadata de un formulario, el label incluye el último
                                    // componente, que describe el flag (p.ej. "Estado del formulario"). Al ser estados
                                    // configurables ese texto puede cambiar y ser relevante
                                    change.elementChanged = !sameLabel(change.label, newLabel);
                                    // GARU-8074 Si viene un v1_label, es que se ha cambiado el índice del label en 2024.01
                                    // para hacerlo coincidir con el __id del item, en lugar de la posición del array
                                    // Lo marcamos como cambio de index
                                    if (change.v1_label && change.action !== 'add-item') {
                                        change.indexChanged = true;
                                    }
                                } else {
                                    // campo que pertenece a un ítem de lista, y que además ese ítem de lista se
                                    // ha eliminado de los datos
                                    change.itemDeleted = true;
                                }
                            }
                            if (change.elementChanged) {
                                change.newLabel = newLabel;
                            }
                        } else {
                            // campo que ya no existe en el CRF
                            // esto no señala campos dentro de ítems de listas que se hayan borrado
                            change.fieldId = change.uid[change.uid.length - 1];
                            change.elementDeleted = true;
                        }
                    } else {
                        change.fieldUId = 'empty';
                        // se trata de un cambio no asociado a un elemento
                        // (p.ej. cambio de ID de record manual, etc.)
                        if (change.uid === null && angular.isArray(change.label) && change.label.length === 0) {
                            // GARU-3285 Audit log mal formateado, es un cambio de ID de paciente (ya que es el
                            // único cambio posible fuera de datos y metadatos)
                            change.label = ['ID ' + CrdConfigurationService.getLabelSingular()];
                        }
                    }
                }

                return change;
            }

            function _isValidChange(change) {
                if (['global-metadata', 'form-metadata'].indexOf(change.action) === -1) {
                    return true;
                }

                // Si el cambio es de falsey a falsey no tiene sentido presentarlo
                // Se quita aquí a falta de limpiarlo en los datos
                return !!change.before || !!change.after;
            }

            function _getChangeFormat(change) {
                if (['global-metadata', 'form-metadata'].indexOf(change.action) > -1) {
                    return 'metadata';
                }

                if (change.action === 'store-record') {
                    return 'store';
                }

                // GARU-4582 Identificamos los campos de tipo lista de ficheros
                if (seemsFieldFilesChange(change)) {
                    return change.type === 'dicom' ? 'dicom' : 'fieldfiles';
                }

                // No hay formato específico
                return null;
            }

            // Control en front de elementos expandidos
            vm.expandedElements = {};

            vm.hideElement = function(index) {
                vm.expandedElements[index] = false;
            };

            vm.toggleElement = function(index) {
                vm.expandedElements[index] = !vm.expandedElements[index];
            };

            vm.showReason = CrdConfigurationService.getAudit().hasReason();

            function seemsFieldFilesChange(change) {
                // aceptamos cambios de undefined a array y de array a undefined
                var valueBefore = angular.isDefined(change.before) ? change.before : [];
                var valueAfter = angular.isDefined(change.after) ? change.after : [];

                if (!angular.isArray(valueBefore) || !angular.isArray(valueAfter)) {
                    return false;
                }

                var allValues = valueBefore.concat(valueAfter);

                return allValues.length > 0 && allValues.every(function(value) {
                    return angular.isDefined(value.filename);
                });
            }
        }]);
